import BaseControl from "./BaseControl"
import CDropdown from "./CDropdown" 
import Label from "./Label"

const DropdownControl = ({
    text="Text",
    textColor="",
    caption="",
    captionColor="",
    selected=0, // selected item on the list
    items=["Item 1", "Item 2", "Item 3"],
    colors=[""],
    edit=true,
    onSelected=(key:string|null,index:number)=>{}}) => {
    return <BaseControl textColor={textColor} text={text} caption={caption} captionColor={captionColor}>
        <>
        {edit && <div>
            <CDropdown selected={selected} 
                items={items}
                colors={colors}
                onSelected={onSelected}/>
        </div>}
        { !edit && <Label fontWeight="400" color={textColor} textAlign='end' padding="">{items[selected]}</Label>}
        </>
    </BaseControl>
}

export default DropdownControl
